import styled from 'styled-components';

export const Container = styled.section`
  width: auto;
  max-width: 1064px;
  margin: 0 auto;
`;
